import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintEdi_ds_find_orders_for_revisionsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { project_lookup?: string, type_id?: number, lookup_code?: string, owner_reference?: string, vendor_reference?: string, max_order_id?: number, order_class?: string, fulfillment_date?: string, owner_lookup?: string }): 
  Promise<{ result: { Id?: number, FulfillmentDate?: string, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, VendorReference?: string, OrderClass?: { OrderTypeId?: number }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, LoadContainerSequence?: number, DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number }[] } }[], DockAppointmentsOrdersLookup?: { DockAppointmentId?: number }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { project_lookup?: string, type_id?: number, lookup_code?: string, owner_reference?: string, vendor_reference?: string, max_order_id?: number, order_class?: string, fulfillment_date?: string, owner_lookup?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, FulfillmentDate?: string, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, VendorReference?: string, OrderClass?: { OrderTypeId?: number }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, LoadContainerSequence?: number, DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number }[] } }[], DockAppointmentsOrdersLookup?: { DockAppointmentId?: number }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { project_lookup?: string, type_id?: number, lookup_code?: string, owner_reference?: string, vendor_reference?: string, max_order_id?: number, order_class?: string, fulfillment_date?: string, owner_lookup?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, FulfillmentDate?: string, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, VendorReference?: string, OrderClass?: { OrderTypeId?: number }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, LoadContainerSequence?: number, DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number }[] } }[], DockAppointmentsOrdersLookup?: { DockAppointmentId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      project_lookup?: string, type_id?: number, lookup_code?: string, owner_reference?: string, vendor_reference?: string, max_order_id?: number, order_class?: string, fulfillment_date?: string, owner_lookup?: string    }) {
      return false;
    }
}
